/* eslint-disable jsx-a11y/label-has-for */
import React from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import selectors from "./selectors";
import { DotLoader } from "react-spinners";
import actions from "../../actions";
import { paths } from "../../../../../common/constants";

class Admins extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      admins: [],
      pageNumber: 1,
      limit: 10,
    };
    this.redirect = this.redirect.bind(this);
  }
  componentDidMount() {
    const { getAdmins } = this.props;

    getAdmins()
      .then(({ result: { data } }) => {
        const admin = data.data;
        this.setState({ admins: admin });
      })
      .catch(() => {
        toast.error("Internal Server Error");
      });
  }

  redirect() {
    const {
      history: { push },
    } = this.props;
    push(paths.build(paths.client.ADMIN_ADMINS_ADD));
  }
  render() {
    const { isAdminsLoaded } = this.props;
    const { admins, pageNumber, limit } = this.state;

    const TableContent = () =>
      admins.map((admin, key) => (
        <tr key={key}>
          <td>{(pageNumber - 1) * limit + key + 1}</td>
          <td>{admin.admin_id}</td>
          <td>{admin.email}</td>
          <td>{admin.create_date}</td>
        </tr>
      ));

    const content = (
      <section>
        <div className="row mb-4">
          <div className="col-sm-12 col-md-6">
            <div className="align-vertical">
              <button
                className="button button-add"
                onClick={() => this.redirect()}
              >
                <i className="fa fa-plus table-action-but" />
                Add Admins
              </button>
            </div>
          </div>
        </div>
        <div className="row mb-4">
          <div className="col">
            <div id="admins">
              <table
                className="table table-striped table-bordered table-sm"
                cellSpacing="0"
                width="100%"
              >
                <thead>
                  <tr>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">No</div>
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Admin ID</div>
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Email</div>
                      </div>
                    </th>
                    <th className="th-sm">
                      <div className="d-flex">
                        <div className="th-title">Create Date</div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <TableContent />
                </tbody>
              </table>
              {!isAdminsLoaded ? (
                <div className="spinner-container">
                  <DotLoader sizeUnit="px" size={50} color="#00DD8C" />
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </section>
    );

    return (
      <React.Fragment>
        <Row>
          <Col xs="12">
            <Card>
              <CardBody>{content}</CardBody>
            </Card>
          </Col>
        </Row>
      </React.Fragment>
    );
  }
}

Admins.defaultProps = {};

Admins.propTypes = {
  isAdminsLoaded: PropTypes.bool.isRequired,
  admins: PropTypes.object.isRequired,
  getAdmins: PropTypes.func.isRequired,
};

export default connect(selectors, {
  ...actions.admin,
})(withRouter(Admins));



// WEBPACK FOOTER //
// ./client/react/Admin/views/Admins/index.jsx